import {AbstractSerialBadgeType} from './abstract-serial-badge-type';

export class MorningImpulseBadgeType extends AbstractSerialBadgeType {
  constructor() {
    super();
    this.name = 'morningImpulse';
    this.prettyName = 'Morgenimpuls';
    this.icon = 'comments';
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/badges/morning-impulse-badge-type.ts